<div class="c-filters">
  <form class="c-form" autocomplete="off">
    <div class="c-filters__content">
      <div class="l-grid">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="c-filters__actions">
      <button type="button" class="c-button c-button--ghost" [disabled]='isLoading' (click)="onReinitializeFilters()">
        <i class="fa fa-redo"></i>
        {{ 'BUTTON.reinitialise' | translate }}
      </button>
      <myabvv-search-button [disabled]="isLoading" (searchClick)="onApplyFilter()"></myabvv-search-button>
    </div>
  </form>
</div>
